import { useTranslation } from "react-i18next";
import DateTime from "utils/datetime";
import singleModeV2 from "./filterBaseSingle_V2";

const dt = new DateTime();

const rawItems = [
	{
		key: "latest",
		value: "any",
		meta: { url: "any" },
	},
	{
		key: "today",
		value: dt.format("YYYY-MM-DD"),
		content: dt.format("DD.MM.YYYY"),
		meta: {
			url: dt.format("YYYY-MM-DD"),
		},
	},
	{
		key: "yesterday",
		value: dt.modify(`-1 day`).format("YYYY-MM-DD"),
		content: dt.format("DD.MM.YYYY"),
		meta: {
			url: dt.format("YYYY-MM-DD"),
		},
	},
	{
		key: "1DayAgo",
		value: dt.modify(`-1 day`).format("YYYY-MM-DD"),
		content: dt.format("DD.MM.YYYY"),
		meta: {
			url: dt.format("YYYY-MM-DD"),
		},
	},
	{
		key: "2DayAgo",
		value: dt.modify(`-1 day`).format("YYYY-MM-DD"),
		content: dt.format("DD.MM.YYYY"),
		meta: {
			url: dt.format("YYYY-MM-DD"),
		},
	},
	{
		key: "3DayAgo",
		value: dt.modify(`-1 day`).format("YYYY-MM-DD"),
		content: dt.format("DD.MM.YYYY"),
		meta: {
			url: dt.format("YYYY-MM-DD"),
		},
	},
	{
		key: "4DayAgo",
		value: dt.modify(`-1 day`).format("YYYY-MM-DD"),
		content: dt.format("DD.MM.YYYY"),
		meta: {
			url: dt.format("YYYY-MM-DD"),
		},
	},
	{
		key: "5DayAgo",
		value: dt.modify(`-1 day`).format("YYYY-MM-DD"),
		content: dt.format("DD.MM.YYYY"),
		meta: {
			url: dt.format("YYYY-MM-DD"),
		},
	},
];

export { rawItems };

export const compute = {};

const useFilterActivityDate = ({ initial = "any" }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const items = rawItems.map((item) => ({
		...item,
		content: item.content ?? t("filtersAndSelectors:period.latest"),
	}));

	return {
		items,
		compute,
		...singleModeV2({ items, compute, initial }),
	};
};

export default useFilterActivityDate;
